import { AppEndpoint } from 'app/app.endpoints';
import { IProvisioningResponse } from 'app/main/pages/plans/interfaces/plan.interface';
import { HttpErrorRes } from 'app/main/shared/types/HttpErrorRes.type';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
    Plan, PlanConsumption
} from '../pages/customers/plan-consumption/plan-consumption.interface';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: "root" })
export class PlanService {
  private url = AppEndpoint.BASE_URL + "/private" + "/plans";
  constructor(
    private _auth: AuthenticationService,
    private _http: HttpClient,
    private readonly toastr: ToastrService
  ) {}

  createPlan = (planData): Observable<any> =>
    this._http.post(`${this.url}/create`, planData).pipe(
      catchError((error: HttpErrorRes) => {
        if (error.details.message === "plan_name_for_company_already_exists")
          this.toastr.warning("Ya existe un plan con el mismo nombre");
        else this.toastr.error("Ocurrió un error al crear el plan");
        throw error;
      })
    );

  getPlans = (enabled: string = "enabled"): Observable<any> =>
    this._http.get(`${this.url}/list`, { params: { enabled } });

  downloadCSV = (filters?): Observable<Blob> => {
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    const options = {
      headers,
      responseType: "blob" as "json",
    };
    return this._http.get<Blob>(`${this.url}/download-plans`, options);
  };

  getByOwner = (companyId: number): Observable<any> =>
    this._http.get(`${this.url}/list-by-owner/${companyId}`);

  getById = (planId: number): Observable<any> =>
    this._http.get(`${this.url}/${planId}`);

  getMyPlan = (): Observable<Plan> =>
    this._http.get<Plan>(`${this.url}/my-plan`);

  getPlanConsumedStatus = (): Observable<PlanConsumption[]> =>
    this._http.get<PlanConsumption[]>(`${this.url}/plan-status-consumed`);

  getPlanNextReceiptDate = (): Observable<any> =>
    this._http.get<any>(`${this.url}/next-date/${this._auth.companyId}`);

  updatePlan = (planId: number, planData = {}): Observable<any> =>
    this._http.put(`${this.url}/${planId}`, planData).pipe(
      catchError((error: HttpErrorRes) => {
        if (error.details.message === "plan_name_for_company_already_exists")
          this.toastr.warning("Ya existe un plan con el mismo nombre");
        else this.toastr.error("Ocurrió un error al actualizar el plan");
        throw error;
      })
    );

  planExists = (name: string): Observable<any> =>
    this._http.get(`${this.url}/exists/${name}`);

  // * Provisioning
  getProvisioning = (planId: number): Observable<IProvisioningResponse[]> =>
    this._http.get<IProvisioningResponse[]>(
      `${this.url}/provisioning/${planId}`
    );

  // * Products
  getProductsByPlanId = (planId: string): Observable<any[]> =>
    this._http.get<any[]>(`${this.url}/provisioning/products/${planId}`);

  get companyId() {
    return this._auth.companyId;
  }

  get userId() {
    return this._auth.userId;
  }
}
